import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import crops from './crops.router';
import account from './account.router';
import farms from './farms.router';
import program from './program.router';
import fertilizers from './fertilizers.router';
import tests from './tests/tests.router';
import labs from './labs.router';
import satellite from './satellite.router';
import main from './main.router';
import market from './market.router';
import support from './support.router';
import reports from './reports.router';
import subs from './subs.router';
import drainage from './drainage.router';
import pdf from './pdf.router';

import Dashboard from '@/views/Dashboard';
import Plans from '@/views/plans/Plans';
import ThankYou from '@/views/thanks/ThankYou.vue'

export default {
  path: '/dashboard',
  component: Dashboard,
  beforeEnter: multiguard([ middleware.isLogged ]),
  children: [
    crops,
    account,
    farms,
    program,
    tests,
    fertilizers,
    labs,
    main,
    reports,
    support,
    satellite,
    subs,
    drainage,
    market,
    pdf,
    {
      path: 'plans',
      component: Plans,
      name: 'dashboard-plans',
      meta: { title: 'Our Plans' },
    },
    {
      path: 'thank-you',
      component: ThankYou,
      name: 'thank-you',
      meta: { title: 'Thank you!' },
    },
    {
      path: '',
      component: Plans,
      name: 'dashboard',
      meta: { title: 'Dashboard' },
      // redirect from empty page
      beforeEnter: function (to, from, next) {
        if(to.name === 'dashboard') {
          next('/dashboard/main');
        } else {
          next();
        }
      },
    },
  ]
};
